import React from 'react';

import { cn } from '@/helpers/shadCnUtils';
import { Icon } from '@/new/components/icon';
import { Button } from '@/new/components/shadcn/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/new/components/shadcn/tooltip';

interface TooltipIconProps {
  tooltipContent: string;
}

export const TooltipIcon: React.FC<TooltipIconProps> = React.memo(({ tooltipContent }) => (
  <TooltipProvider>
    <Tooltip delayDuration={0}>
      <TooltipTrigger asChild>
        <Button variant="ghost" size="icon" className="p-0">
          <Icon className="lucide--info h-4 w-4 cursor-pointer text-gray-400" />
        </Button>
      </TooltipTrigger>

      <TooltipContent side={'top'} sideOffset={8} className={cn('bg-gray-50')}>
        <p className="text-xs text-gray-800">{tooltipContent}</p>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
));
